import { render, staticRenderFns } from "./ScratchTicket.vue?vue&type=template&id=25bf559b&scoped=true&"
import script from "./ScratchTicket.vue?vue&type=script&lang=js&"
export * from "./ScratchTicket.vue?vue&type=script&lang=js&"
import style0 from "./ScratchTicket.vue?vue&type=style&index=0&id=25bf559b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bf559b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25bf559b')) {
      api.createRecord('25bf559b', component.options)
    } else {
      api.reload('25bf559b', component.options)
    }
    module.hot.accept("./ScratchTicket.vue?vue&type=template&id=25bf559b&scoped=true&", function () {
      api.rerender('25bf559b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MarketingActivityEdit/ActivePages/ScratchTicket.vue"
export default component.exports